import fetch from "@/utils/fetch2";

/**
 * 查询单位数据
 * @param params
 * @returns {*}
 */
export function listChartData(params) {
  return fetch({
    url: "/statistics/listChartData",
    method: "post",
    data: params,
  });
}

/**
 * 查询数据
 * @param params
 * @returns {*}
 */
export function listData(params) {
  return fetch({
    url: "/statistics/listData",
    method: "post",
    data: params,
  });
}

/**
 * 参检单位资质占比  单资质、双资质
 * @param params
 * @returns {*}
 */
export function getChartData1(params) {
  return fetch({
    url: "/statistics/getChartData1",
    method: "post",
    data: params,
  });
}

/**
 * 参检单位资质数量统计 音像、电子
 * @param params
 * @returns {*}
 */
export function getChartData2(params) {
  return fetch({
    url: "/statistics/getChartData2",
    method: "post",
    data: params,
  });
}

/**
 * 检单位资质数量统计 zizhi
 * @param params
 * @returns {*}
 */
export function getChartData3(params) {
  return fetch({
    url: "/statistics/getChartData3",
    method: "post",
    data: params,
  });
}

/**
 * 参检单位资质2数量统计 zizhi2
 * @param params
 * @returns {*}
 */
export function getChartData4(params) {
  return fetch({
    url: "/statistics/getChartData4",
    method: "post",
    data: params,
  });
}

/**
 *
 * @param params
 * @returns {*}
 */
export function getChartData5(params) {
  return fetch({
    url: "/statistics/getChartData5",
    method: "post",
    data: params,
  });
}

/**
 *
 * @param params
 * @returns {*}
 */
export function getChartData6(params) {
  return fetch({
    url: "/statistics/getChartData6",
    method: "post",
    data: params,
  });
}

/**
 *
 * @param params
 * @returns {*}
 */
export function getChartData7(params) {
  return fetch({
    url: "/statistics/getChartData7",
    method: "post",
    data: params,
  });
}

/**
 * 音电出版物信息 出版数量
 * @param params
 * @returns {*}
 */
export function getChartData11(params) {
  return fetch({
    url: "/statistics/getChartData11",
    method: "post",
    data: params,
  });
}

/**
 * 音电出版物信息 时长
 * @param params
 * @returns {*}
 */
export function getChartData12(params) {
  return fetch({
    url: "/statistics/getChartData12",
    method: "post",
    data: params,
  });
}

/**
 * 音像制品内容来源类型
 * @param params
 * @returns {*}
 */
export function getChartData13(params) {
  return fetch({
    url: "/statistics/getChartData13",
    method: "post",
    data: params,
  });
}

/**
 * 书配盘标记-中文
 * @param params
 * @returns {*}
 */
export function getChartData14(params) {
  return fetch({
    url: "/statistics/getChartData14",
    method: "post",
    data: params,
  });
}

/**
 * 实（载）体、网络传播
 * @param params
 * @returns {*}
 */
export function getChartData15(params) {
  return fetch({
    url: "/statistics/getChartData15",
    method: "post",
    data: params,
  });
}

/**
 * 实（载）体
 * @param params
 * @returns {*}
 */
export function getChartData16(params) {
  return fetch({
    url: "/statistics/getChartData16",
    method: "post",
    data: params,
  });
}

/**
 * 除传统光盘载体出版外在哪些方面有所拓展
 * @param params
 * @returns {*}
 */
export function getChartData17(params) {
  return fetch({
    url: "/statistics/getChartData17",
    method: "post",
    data: params,
  });
}

/**
 * 音像制品出版单位结合音像电子业务开设并运营的项目数量
 * @param params
 * @returns {*}
 */
export function getChartData18(params) {
  return fetch({
    url: "/statistics/getChartData18",
    method: "post",
    data: params,
  });
}

/**
 * 音电 实（载）体出版销售数量（张/盒）
 * @param params
 * @returns {*}
 */
export function getChartData181(params) {
  return fetch({
    url: "/statistics/getChartData181",
    method: "post",
    data: params,
  });
}

/**
 * 音电 实（载）体出版年收入
 * @param params
 * @returns {*}
 */
export function getChartData182(params) {
  return fetch({
    url: "/statistics/getChartData182",
    method: "post",
    data: params,
  });
}

/**
 * 音电 网络传播年收入
 * @param params
 * @returns {*}
 */
export function getChartData183(params) {
  return fetch({
    url: "/statistics/getChartData183",
    method: "post",
    data: params,
  });
}

/**
 * 人员分类
 * @param params
 * @returns {*}
 */
export function getChartData31To40(params) {
  return fetch({
    url: "/statistics/getChartData31To40",
    method: "post",
    data: params,
  });
}

/**
 * 注册资本、资产及负债情况
 * @param params
 * @returns {*}
 */
export function getChartData51(params) {
  return fetch({
    url: "/statistics/getChartData51",
    method: "post",
    data: params,
  });
}

/**
 * 利润率
 * @param params
 * @returns {*}
 */
export function getChartData52(params) {
  return fetch({
    url: "/statistics/getChartData52",
    method: "post",
    data: params,
  });
}

/**
 *
 * @param params
 * @returns {*}
 */
export function getFinanceChart1(params) {
  return fetch({
    url: "/hzbfinance/getTotalChart",
    method: "post",
    data: params,
  });
}

export function getFinanceDetail(params) {
  return fetch({
    url: "/hzbfinance/getFinanceDetail",
    method: "post",
    data: params,
  });
}

export function getProvinceFinanceChart(params) {
  return fetch({
    url: "/hzbfinance/getProvinceFinanceChart",
    method: "post",
    data: params,
  });
}

export function getProvinceFinanceDetail(params) {
  return fetch({
    url: "/hzbfinance/getProvinceFinanceDetail",
    method: "post",
    data: params,
  });
}

export function getWorkerBaseInfo(params) {
  return fetch({
    url: "/hzbworkerbase/getTotalInfo",
    method: "post",
    data: params,
  });
}

export function getLxdzInfo(params) {
  return fetch({
    url: "/hzblxdzfinance/getLxdzInfo",
    method: "post",
    data: params,
  });
}

export function getLxdzDetail(params) {
  return fetch({
    url: "/hzblxdzfinance/getLxdzDetail",
    method: "post",
    data: params,
  });
}



// WEBPACK FOOTER //
// ./src/api/adminRole/statisticsAnalysis.js